export default {
  computed: {
    missionSettings() {
      return this.$store.state.activities['mission-reward'].missionsSettings
    }
  },
  watch: {
    missionSettings(value) {
      // To redirect to home page, status must be false only
      if (value.status === false) {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    // Check if the mission setting is disabled
    // and redirect to the home page
    if (this.missionSettings?.status === false) {
      this.$router.push('/')
    }

    // To set mission basic setting
    this.$store.dispatch('activities/mission-reward/getMissionSettings', {
      currency: this.$store.state.settings.defaultCurrency
    })
  }
}
